import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Challenge } from '@app/model/challenge';
import { NavigateFrom } from '@app/model/enums/navigate-from.enum';
import { ChallengeApiService } from '@app/services/api/challenge-api.service';
import { SwiperComponent } from 'library-explorer';
import { finalize, mergeMap } from 'rxjs/operators';

@Component({
    selector: 'app-challenge-block',
    templateUrl: './challenge-block.component.html',
    styleUrls: ['./challenge-block.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChallengeBlockComponent implements OnInit {
  @Input() block: any;

  @ViewChild(SwiperComponent) swiperComponent: SwiperComponent;

  public isJoinLoading = false;

  public carouselConfig = {
    breakpoints: {
      0: {
        reducedWidth: true,
        showOverflow: true
      },
      480: {
        reducedWidth: false,
        showOverflow: false
      }
    }
  }

  constructor(
    private readonly challengeApiService: ChallengeApiService,
    private readonly router: Router) { }

  ngOnInit(): void {
  }

  public joinChallenge(challenge: Challenge): void {
    if (challenge.isJoined) {
      this.continueChallenge(challenge);
      return;
    }

    this.isJoinLoading = true;

    this.challengeApiService.joinChallenge(challenge.id)
      .pipe(
        finalize(() => this.isJoinLoading = false)
      )
      .subscribe(() => {
        this.continueChallenge(challenge);
      });
  }


  public continueChallenge(challenge: Challenge): void {
    const nextQuiz = challenge.contents.find(quiz => !quiz.progress);

    if (!nextQuiz) {
      return;
    }

    this.router.navigate(['/chapters'], {
      queryParams: {
        lessonID: nextQuiz.id,
        from: NavigateFrom.CHALLENGE,
        fromId: challenge.id
      }
    });
  }

  public navigateToChallenge(challenge: Challenge): void {
    this.router.navigate(['/challenge', challenge.id]);
  }
}
